import { axios } from '@/services/axios';

export const getRegistrar = (registrarId) => {
    const endpoint = `/TRSRegistrar/${registrarId}`;
    const res = axios.get(endpoint);
    return res;
};
